import { Globe } from "lucide-react";
import { useI18n, LANGS } from "@/lib/i18n";

export default function LanguageSwitcher({ inverse = false }) {
  const { lang, setLang } = useI18n();
  return (
    <div className={`inline-flex rounded-lg overflow-hidden border ${inverse ? "border-white/30 bg-white/10" : "border-slate-200 bg-white"}`} data-testid="lang-switcher">
      {LANGS.map((l) => (
        <button
          key={l.code}
          onClick={() => setLang(l.code)}
          className={`px-3 py-1 text-xs font-semibold transition ${
            lang === l.code
              ? (inverse ? "bg-[#f37021] text-white" : "bg-[#004a99] text-white")
              : (inverse ? "text-white/80 hover:bg-white/20" : "text-slate-700 hover:bg-slate-50")
          }`}
          data-testid={`lang-btn-${l.code}`}
          title={l.name}
        >
          {l.label}
        </button>
      ))}
    </div>
  );
}
